import { minutesInHour } from 'date-fns'

export const minutesToHourMinutes = (totalMinutes: number) => {
  const hours = Math.floor(totalMinutes / minutesInHour)
  const minutes = totalMinutes - hours * minutesInHour
  return [hours, minutes]
}
